<template>
  <div id="app">
    <router-view />
    <first-order-reward />
    <audio
      id="voice-system"
      src="./assets/media/im.mp3"
      preload="preload"
      muted="muted"
      style="display: none;"
    ></audio>
    <user-guide />
  </div>
</template>

<script>
import i18n from '@/locales/index'
import userGuide from '@/components/Login/components/user-guide.vue';
import { Message } from 'element-ui';
import TIM from '@/plugins/im';
import { orderInfoTranslate } from '@/filters/index';
import imgHead from '@/assets/images/order-remind-icon.png';
import imgTail from '@/assets/images/icon-arrow-blod.png';
import { mapGetters } from 'vuex';
import FirstOrderReward from '@/components/DialogRedbag/first-order-reward.vue';
import { setCallFn } from '@/utils/imcall';
export default {
  components: {
    userGuide,
    FirstOrderReward
  },
  data() {
    return {
      imgHead,
      imgTail
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    $route: {
      handler: function(to, from) {
        try {
          const gaOptions = window.sessionStorage.getItem('GA_OPTIONS');
          let config = {};
          if (gaOptions) {
            config.campaign = JSON.parse(gaOptions);
          }
          if (from && from.name !== to.name) {
            config.page_path = to.name === 'Chat' ? to.fullPath : to.path;
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
  },
  created() {
    if (window.sessionStorage.getItem('LINE_RECHARGE')) {
      this.$router.replace({
        path: '/line-recharge'
      });
      window.sessionStorage.removeItem('LINE_RECHARGE');
      return;
    }
    this.thirdparyLogin();
    this.setSeoConfig();
    setCallFn('FollowMoment', () => {
      this.$store.dispatch('app/updateFeedFollow', 1);
    });
  },
  mounted() {
    this.webLaunch();
    this.registerTIM();
    this.$store.dispatch('app/getAvatarBorder');
  },
  beforeDestroy() {
    this.gaTimer && clearTimeout(this.gaTimer);
  },
  methods: {
    webLaunch() {
      if (
        location.href.indexOf('line-recharge') !== -1 ||
        this.$route.query.isApp
      )
        return;
      setTimeout(() => {
        this.$adjust('web_launch', {
          user_agent: navigator.userAgent
        });
      }, 1000);
    },
    setSeoConfig() {
      this.$http.get('/seo/config').then(({ data }) => {
        if (data) {
          const titleTag = document.getElementsByTagName('title');
          const descTag = document.getElementsByClassName('meta_desc')[0];
          const keyTag = document.getElementsByClassName('meta_keyword')[0];
          titleTag[0].text = data.title ? data.title : '';
          descTag.content = data.description ? data.description : '';
          keyTag.content = data.keyWord ? data.keyWord : '';
        }
      });
    },
    thirdparyLogin() {
      const firebaseUrl = window.sessionStorage.getItem(
        'beforeJump2LoginFirebase'
      );
      if (firebaseUrl) {
        window.sessionStorage.removeItem('beforeJump2LoginFirebase');
        window.location.replace(firebaseUrl);
        return;
      }
      const isLoginPage = this.$route.name === 'Login';
      if (window.sessionStorage.getItem('isFacebookAppLogin') && !isLoginPage) {
        this.$util.Login();
        return;
      }
      if (window.sessionStorage.getItem('openLogin_1') && !isLoginPage) {
        window.sessionStorage.removeItem('openLogin_1');
        this.$util.Login();
        return;
      }
      const href = window.location.href;
      const start = href.indexOf('?');
      if (start === -1) {
        return;
      }
      const end = href.indexOf('#');
      const paramsStr =
        start < end
          ? href.substring(start + 1, end)
          : href.substring(start + 1);
      const state = sessionStorage.getItem('LineState');
      let flag = false;
      let code = '';
      paramsStr.split('&').forEach(item => {
        const list = item.split('=');
        if (list[0] === 'state' && list[1] === state) flag = true;
        else if (list[0] === 'code') code = list[1];
      }, {});
      const beforeJump2LoginLine = sessionStorage.getItem(
        'beforeJump2LoginLine'
      );
      if (flag && beforeJump2LoginLine) {
        if (sessionStorage.getItem('openLogin')) {
          sessionStorage.removeItem('openLogin');
          sessionStorage.setItem('openLogin_1', 1);
        }

        sessionStorage.removeItem('beforeJump2LoginLine');
        sessionStorage.setItem('lineParams', code);
        location.replace(beforeJump2LoginLine);
      }
    },
    registerTIM() {
      const ellipsis = {
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap'
      };
      TIM.imRegisterNewOrders(data => {
        return new Promise(resolve => {
          if (!(data && data.length) || this.$route.name === 'Chat') return;
          const orderMsg = JSON.parse(data[0].payload.data);
          this.orderRemindMessage({
            dom: this,
            func: () => {
              this.$util.openChatWindow(
                this.userInfo.uuid,
                orderMsg.buyerUserUuid
              );
              resolve();
            },
            content: [
              {
                type: 'icon',
                img: this.imgHead
              },
              {
                type: 'text',
                str: i18n.t('app_1771'),
                style: Object.assign(
                  {
                    margin: '0 8px',
                    'flex-grow': 1
                  },
                  ellipsis
                )
              },
              {
                type: 'icon',
                img: this.imgTail
              }
            ]
          });
        });
      });

      TIM.imRegisterCommand(data => {
        return new Promise(resolve => {
          if (!data) return;
          let jsonData = data.payload.data;
          if (!jsonData) return;
          jsonData = JSON.parse(data.payload.data);
          const routeName = this.$route.name;
          const { Command, ExtraData } = jsonData;
          // const Command = 'QuickMatchGrabbed'
          // const ExtraData = { playerName: 'test' }
          if (!Command || !ExtraData) return;
          const params = { dom: this, duration: 0 };
          if (Command == 'QuickMatchGrabbed') {
            // C端接收，極速下单被陪陪抢单成功后
            if (routeName == 'QuickOrder') return;
            params.content = [
              {
                type: 'text',
                str: i18n.t('app_1772'),
                style: {
                  'flex-shrink': 0
                }
              },
              {
                type: 'text',
                str: ExtraData.playerName || i18n.t('app_1773'),
                style: ellipsis
              },
              {
                type: 'text',
                str: i18n.t('app_1774'),
                style: {
                  'flex-shrink': 0,
                  'flex-grow': 1
                }
              },
              {
                type: 'icon',
                img: this.imgTail
              }
            ];
            params.func = () => {
              if (this.$route.name !== 'QuickOrder') {
                this.$util.openWindow('/quick-order');
              }
              resolve();
            };
          } else if (Command == 'QuickMatchAlarmToGrab') {
            // B端接收，收到新單提醒，極速約單：您有一個新的可搶約單
            // B端該需求，web端暫時不做
            if (routeName == 'QuickOrder') return;
            params.content = [
              {
                type: 'text',
                str: i18n.t('app_1775', [orderInfoTranslate(ExtraData)]),
                style: Object.assign(
                  {
                    'flex-grow': 1
                  },
                  ellipsis
                )
              },
              {
                type: 'icon',
                img: this.imgTail
              }
            ];
            return;
          } else if (Command == 'NewSignUpUserAlarmToPlayer') {
            // 老板注册成功后，给陪陪推荐老板
            if (routeName == 'Chat') return;
            const heshe = ExtraData.sex == 'female' ? '她' : i18n.t('app_1776');
            params.content = [
              {
                type: 'icon',
                img: ExtraData.userAvatarUrl,
                style: {
                  'flex-shrink': 0,
                  'border-radius': '100%',
                  width: '36px',
                  height: '36px',
                  'margin-right': '8px'
                }
              },
              {
                type: 'text',
                str: `${heshe}${
                  ExtraData.gameId
                    ? i18n.t('app_1777', [ExtraData.gameName])
                    : i18n.t('app_1778')
                }，快去私訊${heshe}吧！`
              },
              {
                type: 'icon',
                img: this.imgTail
              }
            ];
            params.func = () => {
              if (this.$route.name !== 'Chat') {
                this.$util.openChatWindow(
                  this.userInfo.uuid,
                  ExtraData.userUuid
                );
              }
              resolve();
            };
          }
          this.orderRemindMessage(params);
        });
      });
    },

    // test(jsonData) {
    //   return new Promise(resolve => {
    //     const routeName = this.$route.name
    //     const ellipsis = {
    //       'overflow': 'hidden',
    //       'text-overflow': 'ellipsis',
    //       'white-space': 'nowrap',
    //     }
    //     // const { Command, ExtraData } = jsonData
    //     const Command = 'NewSignUpUserAlarmToPlayer'
    //     const ExtraData = {"playerUuid":"238613","gameName":"测试游戏","sex":"male","userAvatarUrl":"https://resource.funplus.social/user-static/f5783168-0138-44d1-afbb-428f3a34f11e6370951158262965843.jpg","userUuid":"238988","userNickname":"FBK"}
    //     if (!Command || !ExtraData) return
    //     const params = { dom: this, duration: 0 }
    //     if (Command == 'QuickMatchGrabbed') {
    //       // C端接收，極速下单被陪陪抢单成功后
    //       if (routeName == 'QuickOrder') return
    //       params.content = [{
    //         type: 'text',
    //         str: '極速約單：',
    //         style: {
    //           'flex-shrink': 0
    //         }
    //       }, {
    //         type: 'text',
    //         str: ExtraData.playerName || '有人',
    //         style: ellipsis
    //       }, {
    //         type: 'text',
    //         str: '搶單了，快去看看吧～',
    //         style: {
    //           'flex-shrink': 0,
    //           'flex-grow': 1
    //         }
    //       }, {
    //         type: 'icon',
    //         img: this.imgTail,
    //       }]
    //       params.func = () => {
    //         if (this.$route.name !== 'QuickOrder') {
    //           this.$util.openWindow('/quick-order')
    //         }
    //         resolve()
    //       }
    //     } else if (Command == 'QuickMatchAlarmToGrab') {
    //       // B端接收，收到新單提醒，極速約單：您有一個新的可搶約單
    //       // B端該需求，web端暫時不做
    //       if (routeName == 'QuickOrder') return
    //       params.content = [{
    //         type: 'text',
    //         str: `搶單通知：${ orderInfoTranslate(ExtraData) }`,
    //         style: Object.assign({
    //           'flex-grow': 1,
    //         }, ellipsis)
    //       }, {
    //         type: 'icon',
    //         img: this.imgTail,
    //       }]
    //       return
    //     } else if (Command == 'NewSignUpUserAlarmToPlayer') {
    //       // 老板注册成功后，给陪陪推荐老板
    //       if (routeName == 'Chat') return
    //       params.content = [{
    //         type: 'icon',
    //         img: ExtraData.userAvatarUrl,
    //         style: {
    //           'flex-shrink': 0,
    //           'border-radius': '100%',
    //           'width': '36px',
    //           'height': '36px',
    //           'margin-right': '8px'
    //         }
    //       }, {
    //         type: 'text',
    //         str: ExtraData.gameId ? `${ExtraData.sex == 'female' ? '她' : '他'}可能想玩${ExtraData.gameName}` : '他想玩遊戲' + '，快去私訊他吧！',
    //       }, {
    //         type: 'icon',
    //         img: this.imgTail,
    //       }]
    //       params.func = () => {
    //         if (this.$route.name !== 'Chat') {
    //           this.$util.openChatWindow(this.userInfo.uuid, ExtraData.userUuid)
    //         }
    //         resolve()
    //       }
    //     }
    //     this.orderRemindMessage(params)
    //   })
    // },

    // 通用的全局顶部弹窗（message）方法
    orderRemindMessage({ dom, func, content, duration = 0 }) {
      if (!content) return;
      Message.closeAll();
      const h = dom.$createElement;
      let contentAry = content;
      if (typeof content === 'string') {
        contentAry = [h('span', {}, content)];
      } else {
        contentAry = content.map(item => {
          if (item.type == 'icon') {
            return h('img', {
              class: 'icon',
              attrs: { src: item.img },
              style: item.style || {}
            });
          } else if (item.type == 'text') {
            return h(
              'span',
              {
                style: item.style || {}
              },
              item.str
            );
          }
        });
      }

      const msg = Message({
        message: h(
          'p',
          {
            style: {
              display: 'flex',
              'justify-content': 'flex-start',
              'align-items': 'center',
              width: '100%',
              'font-size': '14px',
              'font-weight': 500,
              cursor: 'pointer'
            },
            on: {
              click: () => {
                if (typeof func === 'function') {
                  func();
                }
                msg.close();
              }
            }
          },
          contentAry
        ),
        duration,
        iconClass: 'none',
        customClass: 'fps-custom-message nowrap',
        offset: window.innerWidth < 600 ? 54 : 66
      });
    }
  }
};
</script>
